/**
 * Class estática responsável por armazenar as strings de eventos.
 */
export class ExtractEventType {
	/**
	 * Constante de eventos do update de extrato
	 */
	static UPDATE = {
		BY_MONTH: 'BY_MONTH',
		BY_PERIOD: 'BY_PERIOD'
	};

	static PERIOD_URL: 'PERIOD_URL';

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/extract/extract.event.type.ts